import { memo } from 'react'
import { isEqual } from 'lodash'
import TumManagementYourUnitContainer from 'app/containers/TumManagementYourUnit'
import { PageTitle } from 'app/components/common/PageTitle'
import { useTranslation } from 'react-i18next'
import R from 'app/assets/R'
import { useAppSelector } from 'app/redux/hooks'

const TumManagementYourUnitCpn = () => {
  const { t } = useTranslation()
  const user = useAppSelector(state => state?.user)?.profile
  return (
    <>
      <PageTitle>{`${t(R.strings.tum_your_unit_management)} "${
        user?.member?.unit?.name ?? ''
      }"`}</PageTitle>
      <TumManagementYourUnitContainer />
    </>
  )
}
export const TumManagementYourUnitPage = memo(TumManagementYourUnitCpn, isEqual)
